import { apiClient } from './api.client';
import { API_ENDPOINTS } from '../config/api.config';
import { 
  Invoice, 
  GenerateInvoiceRequest, 
  InvoiceWithLineItems, 
  InvoiceLineItem,
  CreateMultiTripInvoiceRequest 
} from '../types';

export const invoiceService = {
  getAll: async (): Promise<Invoice[]> => {
    const response = await apiClient.get<Invoice[]>(API_ENDPOINTS.INVOICES.BASE);
    return response.data;
  },

  getById: async (id: number): Promise<Invoice> => {
    const response = await apiClient.get<Invoice>(API_ENDPOINTS.INVOICES.BY_ID(id));
    return response.data;
  },

  getWithLineItems: async (id: number): Promise<InvoiceWithLineItems> => {
    const response = await apiClient.get<InvoiceWithLineItems>(API_ENDPOINTS.INVOICES.BY_ID(id));
    return response.data;
  },

  getLineItems: async (invoiceId: number): Promise<InvoiceLineItem[]> => {
    const response = await apiClient.get<InvoiceLineItem[]>(
      API_ENDPOINTS.INVOICE_LINE_ITEMS.BY_INVOICE(invoiceId)
    );
    return response.data;
  },

  getByDateRange: async (startDate: string, endDate: string): Promise<Invoice[]> => {
    const response = await apiClient.get<Invoice[]>(API_ENDPOINTS.INVOICES.DATE_RANGE, {
      params: { startDate, endDate },
    });
    return response.data;
  },

  generate: async (data: GenerateInvoiceRequest): Promise<Invoice> => {
    const response = await apiClient.post<Invoice>(API_ENDPOINTS.INVOICES.BASE, data);
    return response.data;
  },

  createMultiTrip: async (data: CreateMultiTripInvoiceRequest): Promise<InvoiceWithLineItems> => {
    const response = await apiClient.post<InvoiceWithLineItems>(API_ENDPOINTS.INVOICES.BASE, data);
    return response.data;
  },

  createFromContract: async (contractId: number, data: CreateMultiTripInvoiceRequest): Promise<InvoiceWithLineItems> => {
    const response = await apiClient.post<InvoiceWithLineItems>(
      `${API_ENDPOINTS.INVOICES.BASE}/from-contract/${contractId}`,
      data
    );
    return response.data;
  },

  issue: async (id: number): Promise<Invoice> => {
    const response = await apiClient.post<Invoice>(API_ENDPOINTS.INVOICES.ISSUE(id));
    return response.data;
  },
};
